/* eslint-disable */
import React from 'react';
import { Link } from 'react-router';

import {List, ListItem} from 'material-ui/List';
import Paper from 'material-ui/Paper';
import Subheader from 'material-ui/Subheader';

import ContentInboxIcon from 'material-ui/svg-icons/content/inbox';
import ActionInfoIcon from 'material-ui/svg-icons/action/info';

import TakeActionIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

import ContentItemAction from '../common/content-items/ContentItemAction';
import IsReadTitle from '../common/content-items/IsReadTitle';
import ReadingMaterialItem from '../common/content-items/ReadingMaterialItem';
import VideoItem from '../common/content-items/VideoItem';
import BlogItem from '../common/content-items/BlogItem';
import BookItems from '../common/content-items/BookItems';

const sectionData = {
  "plans-and-acts-strategically" : {
    title: "Plans & Acts Strategically",
    intro: "Builds the quality of McDonald’s employee base by seeking out high performers, helping others develop and grow, rewarding high achievement, and supporting diversity of thought and perspective.",
    sectionOrder: [
      { type : "materials-to-read" },
      { type : "videos" },
      { type : "blogs" },
      { type : "books" }
    ],
    'materials-to-read' : [
      { type: "material-to-read", title:  "Thinking and acting strategically", url: 'http://www.leadershipconsulting.com/thinking-and-acting-strategically-a-critical-leadership-skill.htm', read: true },
      { type: "material-to-read", title:  "Applied strategic Thinking", url: 'https://cmoe.com/products-and-services/applied-strategic-thinking' }
    ],
    videos: [
      { type: "video", title:  "Martin Reeves: Your strategy needs a strategy", url: 'https://www.ted.com/watch/ted-institute/ted-bcg/martin-reeves-your-strategy-needs-a-strategy' }
    ],
    blogs: [
      { type: "blog", title: "blog.strategyzer.com", intro: "The Strategyzer guys are pretty liberal when it comes to sharing content, ideas and insights on the topic of business model design and value proposition design.", url: "http://blog.strategyzer.com" },
      { type: "blog", title: "michael-roberto.blogspot.co.uk", intro : "Accessible commentary on strategy and leadership based on current events, from former Bryant University and ex-Harvard Professor Michael Roberto.", url: "http://michael-roberto.blogspot.co.uk" }
    ],
    books: [
      {
        type: "book",
        coverImg: "book1",
        url: "https://www.getabstract.com/en/summary/sales-and-marketing/value-proposition-design/23309?u=mcdonalds",
        title: "Value Proposition Design",
        author: "Alex Osterwalder +"
      },
      { type: "book",
        coverImg: "book2",
        url: "https://www.getabstract.com/ShowAbstract.do?u=mcdonalds&dataId=4773",
        title: "Blue Ocean Strategy",
        author: "W Chan Kim +"
      },
      { type: "book",
        coverImg: "book3",
        url: "https://www.getabstract.com/ShowAbstract.do?u=mcdonalds&dataId=4685",
        title: "The World Is Flat",
        author: "Thomas Friedman"
      }
    ]
  }
};

class LeadershipCompsSectionPage extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      sectionId: props.routeParams.section,
      sectionData: sectionData[props.routeParams.section]
    };
  }

  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    const thisSectionData = this.state.sectionData;
    const style = {
      col: {
        marginBottom: "15px"
      },
      intro: {
        paddingLeft: "2px",
        paddingRight: "2px",
        paddingBottom: "20px",
        paddingTop: "10px"
      }
    };

    return (
      <div>
        <div style={style.breadcrumb} className="breadcrumb">
          <h4>
            <Link to="/leadership-comps">Leadership Competencies</Link> &nbsp; > &nbsp; {thisSectionData.title}
          </h4>
        </div>
        <Paper className="page-paper">

          <h3>{thisSectionData.title}</h3>
          <p style={style.intro} className="main-text">{thisSectionData.intro}</p>

          <div className="row">
              <div style={style.col} className="col-xs-12
                          col-sm-12
                          col-md-6
                          col-lg-6">
                <Paper>
                  <List>
                    <Subheader>Materials To Read</Subheader>
                    {thisSectionData['materials-to-read'].map(item =>
                      <ReadingMaterialItem
                        key={item.title}
                        item={item}
                      />
                    )}
                  </List>
                </Paper>
              </div>
              <div style={style.col} className="col-xs-12
                          col-sm-12
                          col-md-6
                          col-lg-6">
                <Paper>
                  <List>
                    <Subheader>Videos</Subheader>
                    {thisSectionData.videos.map(item =>
                      <VideoItem
                        key={item.title}
                        item={item}
                      />
                    )}
                  </List>
                </Paper>
              </div>
              <div style={style.col} className="col-xs-12
                          col-sm-12
                          col-md-6
                          col-lg-6">
                <Paper>
                  <List>
                    <Subheader>Blogs</Subheader>
                    {thisSectionData.blogs.map(item =>
                      <BlogItem
                        key={item.title}
                        item={item}
                      />
                    )}
                  </List>
                </Paper>
              </div>
              <div style={style.col} className="col-xs-12
                          col-sm-12
                          col-md-6
                          col-lg-6">
                <Paper>
                    <Subheader>Books</Subheader>
                    <BookItems items={thisSectionData.books}/>
                </Paper>
              </div>
          </div>

        </Paper>
      </div>
    );
  }
}

export default LeadershipCompsSectionPage;



/** WEBPACK FOOTER **
 ** ./src/components/leadership-comps/LeadershipCompsSectionPage.js
 **/